var _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVivilazonaWordmarkWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 520,
    height: 110,
    viewBox: "0 0 520 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 78,
    fontFamily: "Poppins, Arial, sans-serif",
    fontSize: 78,
    fontWeight: 700,
    letterSpacing: -2
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFFFFF"
  }, "Vivi"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFFFFF"
  }, "La"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFFFFF"
  }, "Zona"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVivilazonaWordmarkWhite);
export default __webpack_public_path__ + "static/media/vivilazona-wordmark-white.7f93104809c2d5fd134edf8754cabd51.svg";
export { ForwardRef as ReactComponent };